
define('text!common/views/commercial/creatives/manual-container-cta-soulmates.html',[],function () { return '<a class="button" href="<%=clickMacro%><%=baseUrl%>" data-link-name="joinnow">\n    <%=logosoulmatesjoin%>\n    Join now\n</a>\n';});

